module.exports = __webpack_public_path__ + "img/alhj_btn.b1818fc8.png";